import { create } from 'zustand';

interface SnackbarStore {
  isOpen: boolean;
  message: string;
  showCheckIcon: boolean;
  showErrorIcon: boolean;
  showCloseIcon: boolean;
  duration: number;
  showSnackbar: (message: string, options?: {
    showCheckIcon?: boolean;
    showErrorIcon?: boolean;
    showCloseIcon?: boolean;
    duration?: number;
  }) => void;
  hideSnackbar: () => void;
}

export const useSnackbarStore = create<SnackbarStore>((set, get) => ({
  isOpen: false,
  message: '',
  showCheckIcon: false,
  showErrorIcon: false,
  showCloseIcon: true,
  duration: 3000,
  
  showSnackbar: (message, options = {}) => {
    const { isOpen } = get();
    
    // 이미 열려있으면 먼저 닫고 새로 열기
    if (isOpen) {
      set({ isOpen: false });
      setTimeout(() => {
        set({
          isOpen: true,
          message,
          showCheckIcon: options.showCheckIcon || false,
          showErrorIcon: options.showErrorIcon || false,
          showCloseIcon: options.showCloseIcon !== false,
          duration: options.duration || 3000,
        });
      }, 50);
    } else {
      set({
        isOpen: true,
        message,
        showCheckIcon: options.showCheckIcon || false,
        showErrorIcon: options.showErrorIcon || false,
        showCloseIcon: options.showCloseIcon !== false,
        duration: options.duration || 3000,
      });
    }
  },
  
  hideSnackbar: () => {
    set({ isOpen: false });
  },
}));